<app-sub-panel title="Attachments">
    <div action class="attachment-action">
        <nz-dropdown-menu #subAction="nzDropdownMenu">
            <ul nz-menu nzSelectable>
                <li nz-menu-item (click)="downloadAll()">Download All</li>
            </ul>
        </nz-dropdown-menu>

        <div class="attachment-item" nz-dropdown [nzDropdownMenu]="subAction">
            <span nz-icon nzType="svg:more" class="attachment-icon"></span>
        </div>
        <div class="attachment-item">
            <app-file-upload
                    [isSingleBtn]="true"
                    [showUploadList]="false"
                    [batchUpload]="batchUpload"
                    (uploadEvent)="addFile($event)"
            ></app-file-upload>
        </div>
    </div>
    <div content class="desc-content">
        <app-st
            #st
            [loading]="loading"
            [columns]="columns"
            [data]="data"
            [page]="{ show: true }"
            [ps]="size"
            [pi]="page + 1"
            [total]="total"
            [templates]="{ action: action }"
            (changes)="handleChange($event)"
            [scroll]="nzScroll"
        >
            <ng-template #action let-row let-index="index">
                <div style="display: inline-block">
                    <button nz-tooltip="Download" nz-button nzSize="small"class="text-btn-primary" (click)="handleDownload(row)">
                        <em nz-icon nzType="download" nzTheme="outline"></em>
                    </button>
                </div>

                <button nz-tooltip="Delete" nz-button nzSize="small" class="text-btn-danger" (click)="handleRemove(row, index)">
                    <em nz-icon nzType="delete" nzTheme="outline"></em>
                </button>
            </ng-template>
        </app-st>
    </div>
</app-sub-panel>
